// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FilledOrderItem } from '../../../cache/FilledOrderItem';
import { QuickTableGroupRowCalculator } from './QuickTableColumnAggregateCalculator';
import { Decimal } from 'decimal.js';
export class FilledOrderGroupRowCalculator extends QuickTableGroupRowCalculator {
    getColumnAggregate(columnIndex, rows, groupByColumnIndex, showTotals) {
        if (columnIndex === FilledOrderItem.INSTRUMENT_COL_INDEX) {
            if (groupByColumnIndex !== FilledOrderItem.ORDER_ID_COL_INDEX) {
                return '';
            }
            return rows[0].cells[columnIndex].formattedValue;
        }
        return super.getColumnAggregate(columnIndex, rows, groupByColumnIndex, showTotals);
    }
    calculateValue(columnIndex, rows, groupByColumnIndex) {
        if (columnIndex === FilledOrderItem.PRICE_COL_INDEX) {
            if (groupByColumnIndex !== FilledOrderItem.ORDER_ID_COL_INDEX) {
                return NaN;
            }
            if (rows.length === 1) {
                return rows[0].item.getColumnValue(FilledOrderItem.PRICE_COL_INDEX);
            }
            let sumProduct = 0;
            let sumQuantity = 0;
            for (const row of rows) {
                const price = row.item.trade.Price;
                const quantity = row.item.trade.Amount;
                sumProduct += price * quantity;
                sumQuantity += quantity;
            }
            const avgPrice = new Decimal(sumProduct).dividedBy(sumQuantity).toNumber();
            return avgPrice;
        }
        return super.calculateValue(columnIndex, rows, groupByColumnIndex);
    }
}
